module.exports = __webpack_public_path__ + "assets/Xero.7614691c.svg";